import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';

const Styles = styled.div``;

const SelectTipoOperatividad = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    disabled,
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    const options = [
        {
            value: 'OPERATIVO',
            label: 'OPERATIVO'
        },
        {
            value: 'OPERATIVO CON REQUERIMIENTO',
            label: 'OPERATIVO CON REQUERIMIENTO'
        },
        {
            value: 'NO OPERATIVO',
            label: 'NO OPERATIVO'
        },
        {
            value: 'NO OPERATIVO POR TERCEROS',
            label: 'NO OPERATIVO POR TERCEROS'
        },
        {
            value: 'NO OPERATIVO POR VANDALISMO',
            label: 'NO OPERATIVO POR VANDALISMO'
        },
        {
            value: 'SIN ESTANCO - SIN ENERGIA',
            label: 'SIN ESTANCO - SIN ENERGIA'
        }
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value]);

    return (
        <Styles>
            <Select
                {...defaultProps}
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
                isDisabled={disabled}
            />
        </Styles>
    );
};

SelectTipoOperatividad.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectTipoOperatividad;